const buttons = {
	continue: "Continue",
	cancel: "Cancel",
	confirm: "Confirm",
	back: "Back",
	"back-to-overview": "Back to Overview",
	open: "Open",
	close: "Close",
	signin: "Sign In",
	edit: "Edit",
	save: "Save",
	"click-here": "Click Here",
	deny: "Deny",
	signup: {
		facebook: "Sign up with Facebook",
	},
	"read-more": "Read More",
	"read-less": "Read Less",
	task: {
		finish: "Finish Task",
		create: "Create Task",
		"create-concept": "Save as Concept",
		publish: "Publish",
	},
	"load-more": "Load More",
	skip: "Skip",
	"previous-step": "Previous Step",
	"next-step": "Next Step",
	chat: "Chat",
	sign: "Sign",
	view: "View",
	retry: "Retry",
	signout: "Sign Out",
};

export default buttons;
